/**
 * Pre-compiled es messages for FieldErrors
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  duplicateValue: `Este valor ya está en uso. Debe ser único.`,
  emptyValue: `Este campo no puede estar vacío.`,
  invalidFormat: `Introduce un valor válido.`,
  invalidFractionalNumber: `Se requiere un número entero.`,
  invalidFromServer: `Ha fallado la validación del servidor. Comprueba tus entradas.`,
  invalidNegativeNumber: `Los números negativos no están permitidos.`,
  invalidValue: `El valor proporcionado no es válido.`,
  missingRequiredField: `Este campo es obligatorio. Proporciona un valor.`,
  resourceNotFound: `No se ha encontrado el recurso solicitado.`,
  valueAboveMaximum: `El valor debe ser igual o inferior al máximo.`,
  valueBelowMinimum: `El valor debe ser igual o superior al mínimo.`,
  valueBlocked: `Este valor no está permitido.`,
  valueOutOfRange: `El valor debe estar en un rango aceptable.`,
  valueTooLong: `Este valor es demasiado largo.`,
  valueTooShort: `Este valor es demasiado corto.`,
};
